<div *ngIf="snackBarType === 'timeout'">
  <span style="background-color: inherit; color: white;"
        class="d-flex justify-content-around align-items-center">
    <label style="padding-right: 5px;">Session will expire in: {{seconds}}</label>
    <button mat-flat-button
            (click)="onContinue()">Continue</button>
  </span>
</div>

<div *ngIf="snackBarType === 'notification'">
  <span>
    Notification:
    <button mat-flat-button
            color="warn"
            (click)="onDismiss()">Dismiss</button>
  </span>
</div>
